import {
  CAMPAIGN_MANAGEMENT_APPROVAL,
  CAMPAIGN_MANAGEMENT_APPROVAL_SUCCESS,
  CAMPAIGN_MANAGEMENT_APPROVAL_ERROR,
  CAMPAIGN_MANAGEMENT_APPROVAL_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CampaignManagementApproval = (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGN_MANAGEMENT_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CAMPAIGN_MANAGEMENT_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CAMPAIGN_MANAGEMENT_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CAMPAIGN_MANAGEMENT_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CampaignManagementApproval;
